import './dataExtractorModal.scss';
import { ReportConstantsTracks } from '../ReportConstants';
export class DataExtractorModalController {
    static $inject = ['close', '$state', 'SegmentService'];
    constructor(close, $state, SegmentService) {
        'ngInject';
        this.close = close;
        this.$state = $state;
        this.SegmentService = SegmentService;
    }
    closeModal() {
        this.setTrackingHelpDeskReportDataExtractor(ReportConstantsTracks.HELPDESK_REPORTS_DATAEXTRACTOR_MODAL_CLOSE);
        this.close();
    }
    goToDataExtractor() {
        this.setTrackingHelpDeskReportDataExtractor(ReportConstantsTracks.HELPDESK_REPORTS_DATAEXTRACTOR_MODAL);
        this.$state.go('auth.application.detail.attendance.report.data-extractor');
    }
    setTrackingHelpDeskReportDataExtractor(trackEvent) {
        this.SegmentService.createApplicationTrack({ trackEvent: trackEvent });
    }
}
DataExtractorModalController.$inject = ['close', '$state', 'SegmentService'];
